// Components==============
import {
    faDownload,
    faEdit,
    faEllipsisH,
    faTrash,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'components/UI/Image/Image';
import { motion } from 'framer-motion';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useMediaQ } from 'utilities/useMediaQ';
import { useOnClickOutside } from 'utilities/useOnClickOutside';
import ChangeNameModal from '../Modals/ChangeNameModal';
import DeleteItemModal from '../Modals/DeleteItemModal';
import './Row.module.scss';
// =========================

export default function Row({ doc, lastItem }) {
    const [nameModalIsOpen, setNameModalIsOpen] = useState(false);
    const [deleteItemModalIsOpen, setDeleteItemModalIsOpen] = useState(false);
    const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

    const query = useMediaQ('min', 850);
    const history = useHistory();
    const ref = useRef(null);
    const ellipsesRef = useRef(null);

    useOnClickOutside(
        [ref, ellipsesRef],
        () => setTooltipIsOpen(false),
        tooltipIsOpen
    );

    function openURI(e, uri) {
        if (e.target.tagName === 'svg' || e.target.tagName === 'path') return;

        const link = document.createElement('a');
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    const canEdit = true;
    const canDelete = !doc.parent_id;
    const canDownload = !doc.parent_id;

    return (
        <>
            <div
                styleName="row"
                onClick={(e) =>
                    doc.parent_id
                        ? history.push(`/group/${doc.id}`)
                        : openURI(e, doc.path)
                }
            >
                <div styleName="image">
                    <Image file={doc.path} folder={!!doc.parent_id} />
                </div>
                {query ? (
                    <div styleName="values">
                        <p>{doc?.name}</p>
                        <p>{doc?.created_at}</p>
                        <p>{doc?.user?.name}</p>
                    </div>
                ) : (
                    <div styleName="mobile-values">
                        <p styleName="name">{doc?.name}</p>
                        <p styleName="created-at">{doc?.created_at}</p>
                    </div>
                )}
                {query ? (
                    <div styleName="icons">
                        {canEdit && (
                            <FontAwesomeIcon
                                icon={faEdit}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setNameModalIsOpen(true);
                                }}
                            />
                        )}
                        {canDelete && (
                            <FontAwesomeIcon
                                icon={faTrash}
                                onClick={() => setDeleteItemModalIsOpen(true)}
                            />
                        )}
                        {canDownload && (
                            <a
                                href={doc.path}
                                target="_blank"
                                rel="noreferrer"
                                download
                            >
                                <FontAwesomeIcon icon={faDownload} />
                            </a>
                        )}
                    </div>
                ) : (
                    <div
                        styleName="ellipses"
                        ref={ellipsesRef}
                        onClick={(e) => {
                            e.stopPropagation();
                            setTooltipIsOpen((prev) => !prev);
                        }}
                    >
                        <FontAwesomeIcon icon={faEllipsisH} />
                        {tooltipIsOpen && (
                            <div
                                ref={ref}
                                styleName="tooltip"
                                onClick={(e) => e.stopPropagation()}
                            >
                                {canEdit && (
                                    <div
                                        styleName="tooltip-item"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setNameModalIsOpen(true);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEdit} /> Naam
                                        wijzigen
                                    </div>
                                )}
                                {canDownload && (
                                    <a
                                        href={doc.path}
                                        target="_blank"
                                        rel="noreferrer"
                                        download
                                        styleName="tooltip-item"
                                    >
                                        <FontAwesomeIcon icon={faDownload} />{' '}
                                        Downloaden
                                    </a>
                                )}
                                {canDelete && (
                                    <div
                                        styleName="tooltip-item delete"
                                        onClick={() =>
                                            setDeleteItemModalIsOpen(true)
                                        }
                                    >
                                        <FontAwesomeIcon icon={faTrash} />{' '}
                                        Verwijderen
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
            {!lastItem && <div styleName="bar" />}
            {nameModalIsOpen && (
                <ChangeNameModal
                    setModalIsOpen={setNameModalIsOpen}
                    doc={doc}
                />
            )}
            {deleteItemModalIsOpen && (
                <DeleteItemModal
                    setModalIsOpen={setDeleteItemModalIsOpen}
                    doc={doc}
                />
            )}
        </>
    );
}
